import { render, staticRenderFns } from "./UnternehmenFilters.vue?vue&type=template&id=fbc541ea&scoped=true&"
import script from "./UnternehmenFilters.vue?vue&type=script&lang=ts&"
export * from "./UnternehmenFilters.vue?vue&type=script&lang=ts&"
import style0 from "./UnternehmenFilters.vue?vue&type=style&index=0&id=fbc541ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc541ea",
  null
  
)

export default component.exports